import moment from 'moment';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useGlobal } from '../../../../contexts/Global/context';

import Accordion from '../../../../components/Accordion';
import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';
import Divider from '../../../../components/Divider';
import FormContainer from '../../../../components/FormContainer';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Input from '../../../../components/Inputs/Input';
import Select from '../../../../components/Inputs/Select';
import Modal from '../../../../components/Modal';
import StepProgress from '../../../../components/StepProgress';

import validators from '../../../../utils/defaultValidators';
import steps from '../../../../utils/steps.json';
import validate from '../../../../utils/validateForm';

import { checkIsSupport, cloneObject, handleTopCritics } from '../../../../utils';

import { desligarBeneficiario } from '../../../../services';

import { ContainerButton, PageContainer } from '../../../../styles/styles';

function Beneficiario({ location: { dataBeneficiario, criticas } }) {
    const history = useHistory();

    const { dataActiveContract, setShowSupportModal } = useGlobal();

    if (!dataBeneficiario) dataBeneficiario = {};

    const [modal, setModal] = useState({ title: '', message: '' });
    const [loadingPost, setLoadingPost] = useState(false);
    const [alerts, setAlerts] = useState(criticas || []);
    const [showModal, setShowModal] = useState(false);
    const [dataMovimentacao, setDataMovimentacao] = useState({});
    const [dataForm, setDataForm] = useState({
        dismissalDate: {
            id: 'dismissalDate',
            label: 'Data de cancelamento do plano',
            help: 'Ao desligar o beneficiário, o valor proporcional do plano não será estornado.',
            value:
                (dataActiveContract.isPme || dataActiveContract.isPj) &&
                dataActiveContract.referenciaMovimentacao.dataExclusao &&
                moment(dataActiveContract.referenciaMovimentacao.dataExclusao).toISOString(),
            required: true,
            requiredMessage: 'Preencha a data de cancelamento do plano.',
        },
        dismissalReason: {
            id: 'dismissalReason',
            label: 'Motivo do desligamento',
            value: dataBeneficiario.codigoMotivoExclusao,
            required: true,
            requiredMessage: 'Selecione o motivo do desligamento do beneficiário.',
            options: dataBeneficiario.motivosDesligamento,
        },
    });

    if (!dataBeneficiario.contrato) history.push('/movimentacao_cadastral/selecionar_desligar_beneficiario');

    function checkDismissalDate(form) {
        // CARD 27906 TIRAR trava para ver se PME ou adesao usou data menor que a data indicada
        // if (
        //     !!form.dismissalDate.value &&
        //     !!dataActiveContract.referenciaMovimentacao.dataExclusao &&
        //     dataActiveContract.isPme
        // ) {
        //     const diaSugerido = moment(dataActiveContract.referenciaMovimentacao.dataExclusao).format('D');

        //     if (diaSugerido !== moment(form.dismissalDate.value).format('D')) {
        //         const dataSugerida = moment(dataActiveContract.referenciaMovimentacao.dataExclusao).format(
        //             'DD/MM/YYYY'
        //         );

        //         form.dismissalDate.error = `A data informada não corresponde a data permitida no seu contrato, pode-se informar apenas datas superiores ao dia ${dataSugerida} e dias que sejam ${diaSugerido}`;
        //         form.dismissalDate.error = 'Ao desligar o beneficiário, o valor proporcional do plano não será estornado, já que a data do desligamento foi sugerida pelo sistema, de acordo com o período de utilização.';
        //     }
        // }

        if (!dataActiveContract.isPme) {
            if (moment(form.dismissalDate.value) > moment().add(365, 'days')) {
                form.dismissalDate.error = 'A data não pode ser superior à 365 dias do dia vigente.';
            }
        }
    }

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key]({ ...form, ...dataBeneficiario });

        if (id === 'dismissalDate') {
            checkDismissalDate(form);
        }

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        const field = { ...dataForm[id], value, lookup, unmaskedValue, error: '', ...rest };

        if (
            id === 'dismissalDate' &&
            field.isValidDate &&
            value &&
            dataActiveContract.referenciaMovimentacao.dataExclusao !== value
        ) {
            if (dataActiveContract.isPme) {
                setModal({
                    title: 'Quer mesmo alterar a data de desligamento deste plano?',
                    message:
                        'Ao desligar o beneficiário, o valor proporcional do plano não será estornado, já que a data do desligamento foi sugerida pelo sistema, de acordo com o período de utilização.',
                });
                setShowModal(true);
            }
        }

        setDataForm({
            ...dataForm,
            [id]: field,
        });
    }

    async function handleDeleteBeneficiario() {
        setLoadingPost(true);

        const { validatedForm, isValid } = validate({
            ...dataForm,
            ...dataBeneficiario,
            dataExclusao: dataActiveContract.referenciaMovimentacao.dataExclusao,
        });

        let dismissalValid = true;

        checkDismissalDate(validatedForm);

        if (validatedForm.dismissalDate.error) dismissalValid = false;

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (!isValid || !dismissalValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError)
                    firstElementWithError.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }, 100);

            setLoadingPost(false);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const response = await desligarBeneficiario({
            ...dataMovimentacao,
            codigoTSContrato: dataBeneficiario.contrato.codigoTs,
            numeroContrato: dataBeneficiario.contrato.numero || dataActiveContract.numero,
            codigoTS: dataBeneficiario.codigoTs,
            numeroAssociadoOuNumeroCarteira: dataBeneficiario.carteirinha,
            nomeAssociado: dataBeneficiario.nomeCompleto,
            tipoAssociado: dataBeneficiario.tipo[0], // Primeira letra do tipo, ou seja, T, D ou A
            codigoEmpresa: dataBeneficiario.codigoEmpresa,
            dataExclusao: validatedForm.dismissalDate.value,
            codigoMotivoExclusao: validatedForm.dismissalReason.value,
            referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
        });

        const movimentacao = response.movimentacoes[0];
        const criticasResponse = handleTopCritics(movimentacao.criticas);

        if (criticasResponse.length > 0) {
            setAlerts([...criticasResponse]);

            setDataMovimentacao({
                sequencialMovimentacao: movimentacao.sequencialMovimentacao,
                codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
            });

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);

            setLoadingPost(false);

            return;
        }

        history.push({
            pathname: '/movimentacao_cadastral/validar_desligamento_beneficiario',
            exigeTermoContributario: dataBeneficiario.exigeTermoContributario,
        });
    }

    function handleCancelEditionOfDate() {
        setDataForm({
            ...dataForm,
            dismissalDate: {
                ...dataForm.dismissalDate,
                error: '',
                value: dataBeneficiario.dataExclusao,
                isValidDate: true,
            },
        });

        setShowModal(false);
    }

    return (
        <PageContainer>
            <StepProgress steps={steps.desligarBeneficiario} activeStep={2} />

            {alerts.map((alert) => (
                <Alert type={alert.tipo} title={alert.descricao} message={alert.complemento} />
            ))}

            <Accordion hasCollapse={false} title="Desligar beneficiário">
                <FormContainer>
                    <Input
                        field={{
                            label: 'N° da carteirinha',
                            value: dataBeneficiario.carteirinha,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Nome completo',
                            value: dataBeneficiario.nomeCompleto,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Tipo',
                            value: dataBeneficiario.tipo,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Contrato',
                            value: `${dataBeneficiario.contrato?.numero} - ${dataBeneficiario.contrato?.descricao}`,
                            disabled: true,
                        }}
                    />
                </FormContainer>

                <Divider />

                <FormContainer>
                    <DatepickerMui
                        field={dataForm.dismissalDate}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Select field={dataForm.dismissalReason} onBlur={handleInputBlur} onChange={handleChangeInput} />
                </FormContainer>
            </Accordion>

            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingPost}
                    disabled={loadingPost}
                    onClick={handleDeleteBeneficiario}
                >
                    Desligar
                </Button>
            </ContainerButton>

            <Modal
                title={modal.title}
                subtitle={modal.message}
                visible={showModal}
                onCancel={handleCancelEditionOfDate}
                footer={null}
            >
                <Button type="secondary" onClick={handleCancelEditionOfDate}>
                    Não quero
                </Button>

                <Button onClick={() => setShowModal(false)}>Sim, quero</Button>
            </Modal>
        </PageContainer>
    );
}

export default Beneficiario;
